// @ts-check
import React from 'react';

/**
 * Catches unhandled errors in the React component tree and renders a
 * user-friendly fallback instead of an empty white page.
 *
 * Pass a `resetKey` prop (e.g. the current route pathname) so the boundary
 * automatically recovers when the user navigates away from the broken route.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4rem 2rem',
            textAlign: 'center',
          }}
        >
          <h1>Something went wrong</h1>
          <p>
            An unexpected error occurred. Please try refreshing the page or
            navigating back.
          </p>
          <button
            type="button"
            className="btn btn-maroon"
            onClick={() => window.location.reload()}
          >
            Refresh page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
